"use client";

/**
 * Unified login – single centered card with Customer (default) and Business modes.
 * Mode switch uses a 250ms slide/crossfade; one form keeps inputs stable and accessible.
 */
import { Suspense } from "react";
import Link from "next/link";
import { ThemeToggle } from "@/components/ThemeToggle";
import { UnifiedLoginCard } from "@/components/UnifiedLoginCard";

function LoginContent() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-muted/30 p-4">
      <Link
        href="/"
        className="absolute left-4 top-4 text-sm text-muted-foreground hover:text-foreground transition-colors"
      >
        ← Back to home
      </Link>
      <div className="absolute right-4 top-4">
        <ThemeToggle />
      </div>
      <UnifiedLoginCard />
    </div>
  );
}

export default function LoginPage() {
  return (
    <Suspense
      fallback={
        <div className="min-h-screen flex items-center justify-center bg-muted/30 p-4">
          <div className="w-full max-w-2xl rounded-xl border border-border bg-card shadow-lg animate-pulse h-80 flex" />
        </div>
      }
    >
      <LoginContent />
    </Suspense>
  );
}
